import React, { useMemo } from "react";
import { MenuItemWrapper } from "./styles";
import { useLocation } from "react-router";

function MenuItem({ children, path, subPaths }) {
  let location = useLocation();

  const isSelected = useMemo(() => {
    if (location.pathname === path) {
      return true;
    }
    // Handle wildcard subPaths
    if (subPaths && subPaths.length > 0) {
      return subPaths.some((subPath) => {
        const basePath = subPath.replace("/*", "");
        return location.pathname.startsWith(basePath);
      });
    }

    return false;
  }, [location.pathname, path, subPaths]);

  return (
    <MenuItemWrapper to={path} isSelected={isSelected}>
      <li>{children}</li>
    </MenuItemWrapper>
  );
}

export default MenuItem;
